import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Employee } from '../../../class/employee';
import { EmployeeService } from '../../../service/employee/employee.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { formatDateWithoutHour } from '../../../../../theme/functions/formatDateWithoutHour.function';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-employee',
  templateUrl: './new-employee.component.html',
  styleUrls: ['./new-employee.component.scss']
})
export class NewEmployeeComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Employee;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public name: AbstractControl;
    public lastname_1: AbstractControl;
    public lastname_2: AbstractControl;
    public name_1: AbstractControl;
    public name_2: AbstractControl;
    public identification_number: AbstractControl;
    public gender: AbstractControl;
    public selectedGender: {label: string, value: string};
    public mobile: AbstractControl;
    public mobile2: AbstractControl;
    public mobile3: AbstractControl;
    public mobile4: AbstractControl;
    public email: AbstractControl;
    public address: AbstractControl;
    public latitude: number;
    public longitude: number;
    public addressGoogle: string;
    public overlays: any[];
    public date_birth: AbstractControl;
    public date_hire: AbstractControl;
    public date_left: AbstractControl;
    public salary: AbstractControl;
    public department_id: AbstractControl;
    public venue_id: AbstractControl;
    public departmentSelected: string;
    public employee_position_id: AbstractControl;
    public employee_positionsSelected: string;
    public activated: AbstractControl;
    public companies: AbstractControl;
    public company_phone: AbstractControl;
    public extension: AbstractControl;

    public es: any;

    @ViewChild('search') public searchElementRef: ElementRef;
    public zoom: number;
    public marker: Marker;

    public genderOptions: SelectItem[];

    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public employeeService: EmployeeService,
        public translate: TranslateService,
        private ngZone: NgZone,
        private notificationsService: NotificationsService,
        private mapsAPILoader: MapsAPILoader) {

        this.save_exit = false;

        this.genderOptions = [
            {label: 'Femenino', value: 'Femenino'},
            {label: 'Masculino', value: 'Masculino'},
        ];

        this.es = calendarES();
        // {
        //     firstDayOfWeek: 1,
        //     dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        //     dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        //     dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        //     monthNames: [
        //         'Enero',
        //         'Febrero',
        //         'Marzo',
        //         'Abril',
        //         'Mayo',
        //         'Junio',
        //         'Julio',
        //         'Agosto',
        //         'Septiembre',
        //         'Octubre',
        //         'Noviembre',
        //         'Diciembre'
        //     ],
        //     monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        //     today: 'Hoy',
        //     clear: 'Borrar'
        // };

        this.form = fb.group({
            // 'name': ['', Validators.compose([ Validators.required, Validators.minLength(2), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*$') ])],
            'lastname_1': ['', Validators.compose([Validators.required, Validators.minLength(1),Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*$')])],
            'lastname_2': ['', Validators.compose([Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*$')])],
            'name_1': ['', Validators.compose([Validators.required, Validators.minLength(1),Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*$')])],
            'name_2': ['', Validators.compose([Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*$')])],
            'identification_number': ['', Validators.compose([ Validators.required, Validators.minLength(4),Validators.pattern("^[0-9]*$") ])],
            'gender': ['', Validators.compose([ Validators.required, Validators.minLength(2) ])],
            'mobile': ['', Validators.compose([ Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$') ])],
            'mobile2': ['', Validators.compose([ Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$') ])],
            'mobile3': ['', Validators.compose([ Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$') ])],
            'mobile4': ['', Validators.compose([ Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$') ])],
            'email': ['', Validators.compose([ Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$') ])],
            'address': ['', Validators.compose([ Validators.required, Validators.minLength(2) ])],
            'date_birth': ['', Validators.compose([ Validators.required, Validators.minLength(2) ])],
            'date_hire': [''],
            'date_left': [''],
            'salary': [''],
            'activated': ['', Validators.compose([ Validators.required ])],
            'department_id': ['', Validators.compose([ Validators.required ])],
            'venue_id': ['', Validators.compose([ Validators.required ])],
            'employee_position_id': ['', Validators.compose([ Validators.required ])],
            'companies': [''],
            'company_phone': ['', Validators.compose([ Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$') ])],
            'extension': [''],
        });

        // this.name = this.form.controls['name'];
        this.lastname_1 = this.form.controls['lastname_1'];
        this.lastname_2 = this.form.controls['lastname_2'];
        this.name_1 = this.form.controls['name_1'];
        this.name_2 = this.form.controls['name_2'];
        this.identification_number = this.form.controls['identification_number'];
        this.gender = this.form.controls['gender'];
        this.mobile = this.form.controls['mobile'];
        this.mobile2 = this.form.controls['mobile2'];
        this.mobile3 = this.form.controls['mobile3'];
        this.mobile4 = this.form.controls['mobile4'];
        this.email = this.form.controls['email'];
        this.address = this.form.controls['address'];
        this.date_birth = this.form.controls['date_birth'];
        this.date_hire = this.form.controls['date_hire'];
        this.date_left = this.form.controls['date_left'];
        this.salary = this.form.controls['salary'];
        this.activated = this.form.controls['activated'];
        this.department_id = this.form.controls['department_id'];
        this.venue_id = this.form.controls['venue_id'];
        this.employee_position_id = this.form.controls['employee_position_id'];
        this.companies = this.form.controls['companies'];
        this.company_phone = this.form.controls['company_phone'];
        this.extension = this.form.controls['extension'];

        // set google maps defaults
        this.zoom = 2;
        this.latitude = 39.8282;
        this.longitude = -98.5795;

        this.marker = {
            lat: this.latitude,
            lng: this.longitude,
            label: 'User',
            draggable: true
        };
    }

    ngOnInit() {
        if (this.edit) {
            this.identification_number.setValue(this.edit.identification_number);
            // this.name.setValue(this.edit.name);
            this.lastname_1.setValue(this.edit.lastname_1);
            this.lastname_2.setValue(this.edit.lastname_2);
            this.name_1.setValue(this.edit.name_1);
            this.name_2.setValue(this.edit.name_2);
            this.gender.setValue(this.edit.gender);
            this.selectedGender = {label: this.edit.gender, value: this.edit.gender};
            this.mobile.setValue(this.edit.mobile);
            this.mobile2.setValue(this.edit.mobile2);
            this.mobile3.setValue(this.edit.mobile3);
            this.mobile4.setValue(this.edit.mobile4);
            this.email.setValue(this.edit.email);
            this.address.setValue(this.edit.address);
            if (this.edit.date_birth)
                this.date_birth.setValue(new Date(this.edit.date_birth));
            if (this.edit.date_hire)
                this.date_hire.setValue(new Date(this.edit.date_hire));
            if (this.edit.date_left)
                this.date_left.setValue(new Date(this.edit.date_left));
            this.salary.setValue(this.edit.salary);
            this.activated.setValue(this.edit.activated);
            this.department_id.setValue(this.edit.department_id);
            this.venue_id.setValue(this.edit.venue_id);
            this.employee_position_id.setValue(this.edit.employee_position_id);
            if (this.edit.latitude && this.edit.longitude) {
                const lat = this.edit.latitude;
                const lng = this.edit.longitude;
                const position = {
                    lat : lat,
                    lng : lng
                };
                this.setPosition(position);
            }
            this.companies.setValue(this.edit.companies);
            this.company_phone.setValue(this.edit.company_phone);
            this.extension.setValue(this.edit.extension);
        } else {
            this.activated.setValue(true);
            this.setCurrentPosition();
        }

        // load Places Autocomplete
        this.mapsAPILoader.load().then(() => {
            const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
                types: ['address']
            });
            autocomplete.addListener('place_changed', () => {
                this.ngZone.run(() => {
                // get the place result
                const place: google.maps.places.PlaceResult = autocomplete.getPlace();

                this.addressGoogle = place.formatted_address;
                // verify result
                if (place.geometry === undefined || place.geometry === null) {
                    return;
                }

                // set latitude, longitude and zoom
                this.latitude = place.geometry.location.lat();
                this.longitude = place.geometry.location.lng();
                this.zoom = 17;
                });
            });
        });
    }

    private setCurrentPosition() {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.latitude = position.coords.latitude;
                this.longitude = position.coords.longitude;
                this.zoom = 17;
            });
        }
    }

    private setPosition(position) {
        this.latitude = position.lat;
        this.longitude = position.lng;
        this.zoom = 17;
    }

    public handleMapClick(event) {
        // this.selectedPosition = event.latLng;
        // this.addMarker(this.selectedPosition.lat(), this.selectedPosition.lng());
    }

    public addMarker(lat, lng) {
        const title = (this.name.value !== '') ? this.name.value : 'user';
        this.longitude = lng;
        this.latitude = lat;
        this.overlays = [];
        this.overlays.push(
            new google.maps.Marker({
                position: {
                    lat: lat,
                    lng: lng
                }, title: title}
            )
        );
    }

    markerDragEnd(m: Marker, $event: any) {
        this.latitude = $event.coords.lat;
        this.longitude = $event.coords.lng;
    }

    public cancelEmployee () {
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newEmployee(values);
    }

    public newEmployee(values) {
        var param;

        let companies = [];
        if (values.companies) {
          values.companies.forEach(element => {
            companies.push(element.value);
          });
        }

        if (!this.addressGoogle) {
            this.addressGoogle = values.address;
        }

        let date_left = null;
        if (values.date_left !=null && values.date_left != '') {
            date_left = formatDateWithoutHour(values.date_left);
        }

        let date_birth = null;
        if (values.date_birth != null && values.date_birth != '') {
            date_birth = formatDateWithoutHour(values.date_birth);
        }

        let date_hire = null;
        if (values.date_hire != null && values.date_hire != '')
            date_hire = formatDateWithoutHour(values.date_hire);

        values.name_1 = this.capitalize(values.name_1.trim());
    
        if(values.name_2 != null && values.name_2 != '')
            values.name_2 = this.capitalize(values.name_2.trim());
        
        values.lastname_1 = this.capitalize(values.lastname_1.trim());
        
        if(values.lastname_2 != null && values.lastname_2 != '')
            values.lastname_2 = this.capitalize(values.lastname_2.trim());
        
        var name = values.name_1;

        if (values.name_2)
            name +=  ' ' + values.name_2;

        name += ' ' + values.lastname_1;

        if (values.lastname_2)
            name += ' ' + values.lastname_2;
        
        param = {
            'identification_number': values.identification_number,
            'name': name,
            'lastname_1': values.lastname_1,
            'lastname_2': values.lastname_2,
            'name_1': values.name_1,
            'name_2': values.name_2,
            'gender': values.gender.value,
            'mobile': values.mobile,
            'mobile2': values.mobile2,
            'mobile3': values.mobile3,
            'mobile4': values.mobile4,
            'email': values.email,
            'date_birth': date_birth,
            'date_hire': date_hire,
            'date_left': date_left,
            'salary': values.salary,
            'activated': values.activated,
            'department_id': values.department_id,
            'venue_id': values.venue_id,
            'employee_position_id': values.employee_position_id,
            'address': this.addressGoogle,
            'latitude': this.latitude,
            'longitude': this.longitude,
            'companies': companies,
            'company_phone': values.company_phone,
            'extension': values.extension,
        };

        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.employeeService.updateEmployee(this.edit.id, param)
                :
                this.employeeService.newEmployee(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    public capitalize(sentence) {
        sentence = sentence.toLowerCase();
        sentence = sentence.split(' ');

        for (var i = 0; i < sentence.length; i++)
            sentence[i] = sentence[i][0].toUpperCase() + sentence[i].substring(1);

        sentence = sentence.join(' ');

        return sentence;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/employees/new-employee/new-employee.component.ts